import ChattaCommunityScreen from '~components/new-chat/community/category/[categoryId]'

export default ChattaCommunityScreen
